import { useMoreSurveysBannerQuery } from './useMoreSurveysBannerQuery';
import { useMoreSurveysBannerQuery_profileUrlRef$key } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';

import InitialProfiler from './InitialProfiler.qmee';
import ContinuousProfiler from './ContinuousProfiler.qmee';
import SurveysPageCompactProfiler from './SurveysPageCompactProfiler.qmee';

export type Props = {
  profileUrlRef: useMoreSurveysBannerQuery_profileUrlRef$key;
  className: string;
  version: 'dashboard' | 'earn' | 'more';
};

export default function MoreSurveysBanner({ version, profileUrlRef, className }: Props) {
  const data = useMoreSurveysBannerQuery(profileUrlRef);

  const percentageComplete = data.profileCompletionPercentage?.profileCompletionPercentage ?? 0;

  // If profilerUrl exists, show InitialProfiler, else show ContinuousProfiler with endlessProfilerUrl
  if (data.profilerUrl) {
    return <InitialProfiler data={data} className={className} />;
  }

  if (data.endlessProfilerUrl && version === 'dashboard' && percentageComplete < 100) {
    return (
      <ContinuousProfiler
        data={data}
        className={className}
        profilerTitle={percentageComplete <= 98 ? 'Survey Profile' : 'Boost Your Profile'}
        hasBannerChevron
        version={version}
      />
    );
  }

  if (data.endlessProfilerUrl && version === 'earn' && percentageComplete < 100) {
    return <SurveysPageCompactProfiler data={data} className={className} />;
  }

  if (data.demographicProfileUrl && version === 'more') {
    return (
      <ContinuousProfiler
        data={data}
        className={className}
        profilerTitle={'Edit Survey Profile'}
        profilerSupportingText="Edit your profile and keep it updated for better survey completes."
        hasEditIcon
        version={version}
      />
    );
  }

  return null;
}
